/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UserControllerPermissionLoginViewModel } from "../types/UserControllerPermissionLoginViewModel.ts";

export const userControllerPermissionLoginViewModelSchema = z.object({
  controllerId: z.optional(
    z
      .number()
      .int()
      .describe("ID do controller ao qual a permissão se aplica."),
  ),
  controllerName: z.string().describe("Nome do controller.").nullish(),
}) as unknown as ToZod<UserControllerPermissionLoginViewModel>;
